import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

/**
 * topic method
 * @callback TopicMethod
 * @param {...any} args callback args
 */

/**
 * topic item
 * @typedef TopicItem
 * @property {string} topicName
 * @property {TopicMethod} method
 */
var PubSub = /*#__PURE__*/function () {
  function PubSub() {
    _classCallCheck(this, PubSub);

    /**
     * topic items
     * @type {TopicItem}
     */
    this.topics = [];
  }
  /**
   * subscribe a  topic
   * @param {string} topicName topic name
   * @param {TopicMethod} method topic callback method
   */


  _createClass(PubSub, [{
    key: "subscribe",
    value: function subscribe(topicName, method) {
      this.topics.push({
        topicName: topicName,
        method: method
      });
    }
    /**
     * trigger a topic
     * @param {string} topicName topic name
     * @param  {...any} params topic callback args
     */

  }, {
    key: "publish",
    value: function publish(topicName) {
      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }

      this.topics.filter(function (topic) {
        return topicName === topic.topicName;
      }).forEach(function (topic) {
        return topic.method.apply(null, params);
      });
    }
    /**
     * unsubscribe a specified topic method
     * @param {string} topicName topic name
     * @param {TopicMethod} method topic callback method
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(topicName, method) {
      this.topics = this.topics.filter(function (topic) {
        return topic.topicName === topicName && topic.method === method;
      });
    }
  }]);

  return PubSub;
}();

export default PubSub;